<template>
  <div class="bowler-registration-form">
    <NotificationBanner
      v-if="isSuccess & !isError"
      :message="
        $t('bowler-registration.request-succeeded-message', {
          email: formEmail,
        })
      "
      is-success
    />

    <template v-else>
      <NotificationBanner
        v-if="isError"
        :message="$t('bowler-registration.request-failed-error')"
        is-danger
      />

      <form autocomplete="off" spellcheck="false" @submit.prevent="submit">
        <FormTextInput
          v-model="formEmail"
          name="email"
          type="email"
          :label="$t('field-labels.email')"
          :is-disabled="isLoading"
          is-required
        />

        <FormButton :is-busy="isLoading" :is-disabled="formEmail.length < 1">
          {{ $t('bowler-registration.submit') }}
        </FormButton>
      </form>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'

import FormButton from '@/components/common/FormButton.vue'
import FormTextInput from '@/components/common/FormTextInput.vue'
import NotificationBanner from '@/components/common/NotificationBanner.vue'
import BowlerRegistration from '@/utils/bowler-registration'

/* local state */

const formEmail = ref<string>('')
const isError = ref<boolean>(false)
const isLoading = ref<boolean>(false)
const isSuccess = ref<boolean>(false)

/* actions */

const submit = async (): Promise<void> => {
  isLoading.value = true

  const isRequestSuccessful = await BowlerRegistration.requestRegistration(
    formEmail.value ?? '',
  )

  isSuccess.value = isRequestSuccessful
  isError.value = !isRequestSuccessful
  isLoading.value = false
}
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/globals';

.bowler-registration-form,
.bowler-registration-form > form {
  display: flex;
  flex-flow: column nowrap;
  gap: 1em;
}
</style>
